var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _class2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { alias, equal } from '@ember/object/computed';
import { computed, set, setProperties } from '@ember/object';
import { isPresent, isEmpty, isNone } from '@ember/utils';
import { attr, hasMany } from '@ember-data/model';
import Money from '@square/dashboard-money/models/money';
import NumericEnum from '@square/dashboard-utilities/utils/numeric-enum';
import Enum from '@square/dashboard-utilities/utils/enum';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
import PricingRule from '@square/dashboard-items-data/models/pricing-rule';
import { inject as service } from '@ember/service';
const CalculationPhase = NumericEnum.create(['DISCOUNT_PERCENTAGE_PHASE', 'DISCOUNT_AMOUNT_PHASE', 'FEE_SUBTOTAL_PHASE', 'FEE_TOTAL_PHASE', 'TIP_PHASE', 'SWEDISH_ROUNDING_PHASE', 'SURCHARGE_PHASE', 'SURCHARGE_TOTAL_PHASE', 'APPORTIONED_SURCHARGE_PERCENTAGE_PHASE', 'APPORTIONED_SURCHARGE_AMOUNT_PHASE', 'CARD_SURCHARGE_PHASE']);
const SurchargeType = NumericEnum.create(['UNKNOWN', 'AUTO_GRATUITY', 'CUSTOM', 'CARD_SURCHARGE']);
const AutoEnableType = NumericEnum.create(['UNKNOWN', 'MINIMUM_SEAT_COUNT', 'ALWAYS']);
const SurchargeCalculationType = NumericEnum.create(['FIXED', 'VARIABLE_PERCENTAGE', 'VARIABLE_AMOUNT']);
const TreatmentType = NumericEnum.create(['DO_NOT_USE', 'LINE_ITEM', 'APPORTIONED']);
const MAXIMUM_FRACTION_DIGITS = 2;
const DEFAULT_VARIABLE_SURCHARGE_VALUE = undefined;

// These are the types that are used to display the tax assignment options in the UI.
// These values get mapped to two properties on the model which are `treatmentType` and `taxable`.
// This mapping is defined in `taxAssignmentTypeMap`.
const TaxAssignmentType = new Enum(['APPORTIONED', 'ASSIGNED', 'NON_TAXABLE']);
let Surcharge = (_dec = service(), _dec2 = service(), _dec3 = service(), _dec4 = attr('boolean', {
  defaultValue: false
}), _dec5 = attr('string'), _dec6 = attr('string'), _dec7 = attr('legacy-money'), _dec8 = attr('enum', {
  enumClass: SurchargeType,
  defaultValue: SurchargeType.AUTO_GRATUITY
}), _dec9 = attr('boolean', {
  defaultValue: true
}), _dec10 = attr('enum', {
  enumClass: CalculationPhase,
  defaultValue: CalculationPhase.SURCHARGE_PHASE
}), _dec11 = attr('enum', {
  enumClass: SurchargeCalculationType,
  defaultValue: SurchargeCalculationType.FIXED
}), _dec12 = alias('surchargeCalculationType'), _dec13 = attr('number'), _dec14 = attr('enum', {
  enumClass: AutoEnableType
}), _dec15 = attr('array'), _dec16 = attr('enum', {
  enumClass: TreatmentType,
  defaultValue: TreatmentType.LINE_ITEM
}), _dec17 = hasMany('pricing-rule', {
  autosaved: ['targetProductSet', 'timePeriods']
}), _dec18 = alias('pricingRules.firstObject'), _dec19 = computed('taxableNonItem', 'treatmentType', {
  get() {
    for (const taxAssignmentType of TaxAssignmentType.values) {
      const {
        treatmentType,
        taxableNonItem
      } = this.getTaxAssignmentTypeAttrs(taxAssignmentType) ?? {};
      if (this.treatmentType === treatmentType && this.taxableNonItem === taxableNonItem) {
        return taxAssignmentType;
      }
    }
    return this.taxableNonItem ? TaxAssignmentType.ASSIGNED : TaxAssignmentType.NON_TAXABLE;
  },
  set(_, value) {
    const {
      treatmentType,
      taxableNonItem
    } = this.getTaxAssignmentTypeAttrs(value);
    setProperties(this, {
      treatmentType,
      taxableNonItem
    });
    return value;
  }
}), _dec20 = hasMany('surcharge-fee-membership', {
  async: false
}), _dec21 = equal('surchargeType', SurchargeType.CUSTOM), _dec22 = computed('price', 'percentage', 'surchargeCalculationType', {
  get() {
    if (this.surchargeCalculationType === SurchargeCalculationType.VARIABLE_PERCENTAGE) {
      return true;
    }
    return this.surchargeCalculationType === SurchargeCalculationType.FIXED && isNone(this.price);
  },
  set(key, value) {
    if (value) {
      set(this, 'amountValue', undefined);
    } else {
      set(this, 'percentageValue', undefined);
    }
    return value;
  }
}), _dec23 = alias('isPercentageSurcharge'), _dec24 = computed('surchargeCalculationType', function () {
  const surchargeCalculationType = this.surchargeCalculationType;
  return surchargeCalculationType === SurchargeCalculationType.VARIABLE_AMOUNT || surchargeCalculationType === SurchargeCalculationType.VARIABLE_PERCENTAGE;
}), _dec25 = computed('percentage', 'surchargeCalculationType', {
  get() {
    if (this.surchargeCalculationType !== SurchargeCalculationType.FIXED) {
      return undefined;
    }
    return this.percentage;
  },
  set(key, value) {
    set(this, 'percentage', value);
    return value;
  }
}), _dec26 = computed('price.amount', 'surchargeCalculationType', {
  get() {
    if (this.surchargeCalculationType !== SurchargeCalculationType.FIXED) {
      return undefined;
    }
    if (isEmpty(this.price)) {
      return undefined;
    }
    return this.price.amount;
  },
  set(_, value) {
    const price = Number.isInteger(value) ? Money.fromCents(value) : undefined;
    set(this, 'price', price);
    const [oldPrice] = this.changedAttributes().price ?? [];

    // If new price is the same as the original saved price, then revert back
    // to use the original money object so that the isDirty flag can be reset.
    if (oldPrice?.amount === value) {
      set(this, 'price', oldPrice);
    }
    return value;
  }
}), _dec27 = computed('isPercentage', 'surchargeCalculationType', {
  get() {
    switch (this.surchargeCalculationType) {
      case SurchargeCalculationType.VARIABLE_PERCENTAGE:
        return ItemsV3Base.AmountTypes.VARIABLE_PERCENTAGE;
      case SurchargeCalculationType.VARIABLE_AMOUNT:
        return ItemsV3Base.AmountTypes.VARIABLE_AMOUNT;
      default:
        return this.isPercentage ? ItemsV3Base.AmountTypes.PERCENTAGE : ItemsV3Base.AmountTypes.AMOUNT;
    }
  },
  set(key, value) {
    let surchargeCalculationType;
    switch (value) {
      case ItemsV3Base.AmountTypes.VARIABLE_PERCENTAGE:
        surchargeCalculationType = SurchargeCalculationType.VARIABLE_PERCENTAGE;
        break;
      case ItemsV3Base.AmountTypes.VARIABLE_AMOUNT:
        surchargeCalculationType = SurchargeCalculationType.VARIABLE_AMOUNT;
        break;
      default:
        surchargeCalculationType = SurchargeCalculationType.FIXED;
        break;
    }
    set(this, 'surchargeCalculationType', surchargeCalculationType);
    set(this, 'isPercentage', [ItemsV3Base.AmountTypes.VARIABLE_PERCENTAGE, ItemsV3Base.AmountTypes.PERCENTAGE].includes(value));
    return value;
  }
}), _dec28 = computed('_isAutomatic', 'pricingRule.deleted', 'pricingRules.length', {
  get() {
    if (this._isAutomatic !== undefined) {
      return this._isAutomatic;
    }
    return this.pricingRules.length > 0 && isPresent(this.pricingRule) && !this.pricingRule.deleted;
  },
  set(_, value) {
    return set(this, '_isAutomatic', value);
  }
}), _dec29 = computed('_isAutoWeeklySelected', 'hasWeeklyTimePeriods', {
  get() {
    return this._isAutoWeeklySelected;
  },
  set(_, value) {
    return set(this, '_isAutoWeeklySelected', value);
  }
}), _dec30 = computed('_isAutoHolidaySelected', 'hasHolidayTimePeriods', {
  get() {
    return this._isAutoHolidaySelected;
  },
  set(_, value) {
    return set(this, '_isAutoHolidaySelected', value);
  }
}), _dec31 = computed('pricingRule.timePeriods.length', function () {
  return this.pricingRule?.timePeriods?.length > 0 && this.pricingRule?.timePeriods.isAny('isWeeklySchedule');
}), _dec32 = computed('pricingRule.timePeriods.length', function () {
  return this.pricingRule?.timePeriods?.length > 0 && this.pricingRule?.timePeriods.isAny('isHolidaySchedule');
}), _dec33 = computed('amount.currencyCode', 'intl', 'percentage.formatted', 'price.formatted', 'surchargeCalculationType', function () {
  let currencyCode = this.amount?.currencyCode;
  if (isNone(currencyCode)) {
    currencyCode = Money.defaultCurrencyCode;
  }
  const currencyFormatter = this.formatter.getCurrencyFormatter(currencyCode);
  switch (this.surchargeCalculationType) {
    case SurchargeCalculationType.VARIABLE_AMOUNT:
      return this.intl.t('business.serviceCharges.edit.variablePriceLabel', {
        currencySymbol: currencyFormatter.currencySymbol()
      });
    case SurchargeCalculationType.VARIABLE_PERCENTAGE:
      return this.intl.t('business.serviceCharges.edit.variablePercentageLabel');
    case SurchargeCalculationType.FIXED:
      if (this.price) {
        return this.price.formatted;
      } else {
        return this.formatter.percent(this.percentage, {
          maximumFractionDigits: MAXIMUM_FRACTION_DIGITS
        });
      }
    default:
      return null;
  }
}), _dec34 = computed('hasDirtyFields', 'surchargeFeeMemberships.@each.isDirty', 'pricingRule.isDirty'), _dec35 = computed('surchargeFeeMemberships.@each.{fee,isDeleted}', function () {
  return this.surchargeFeeMemberships.rejectBy('isDeleted').mapBy('fee');
}), _dec36 = computed('surchargeType', 'pricingRule.paymentType', function () {
  return this.surchargeType === SurchargeType.CARD_SURCHARGE;
}), (_class = (_class2 = class Surcharge extends ItemsV3Base {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "userInfo", _descriptor2, this);
    _initializerDefineProperty(this, "formatter", _descriptor3, this);
    _initializerDefineProperty(this, "enabledUnitsAll", _descriptor4, this);
    _initializerDefineProperty(this, "name", _descriptor5, this);
    _initializerDefineProperty(this, "percentage", _descriptor6, this);
    _initializerDefineProperty(this, "price", _descriptor7, this);
    _initializerDefineProperty(this, "surchargeType", _descriptor8, this);
    _initializerDefineProperty(this, "taxableNonItem", _descriptor9, this);
    _initializerDefineProperty(this, "calculationPhase", _descriptor10, this);
    _initializerDefineProperty(this, "surchargeCalculationType", _descriptor11, this);
    _initializerDefineProperty(this, "calculationType", _descriptor12, this);
    _initializerDefineProperty(this, "minimumSeatCount", _descriptor13, this);
    _initializerDefineProperty(this, "autoEnableType", _descriptor14, this);
    _initializerDefineProperty(this, "ecomApplyToFulfillmentTypes", _descriptor15, this);
    _initializerDefineProperty(this, "treatmentType", _descriptor16, this);
    // The Catalog API technically supports many pricing rules being associated
    // with a single surcharge, but in practice we do not support such a
    // scenario and thus there is only ever a single pricing rule
    _initializerDefineProperty(this, "pricingRules", _descriptor17, this);
    _initializerDefineProperty(this, "pricingRule", _descriptor18, this);
    _initializerDefineProperty(this, "taxAssignmentType", _descriptor19, this);
    _initializerDefineProperty(this, "surchargeFeeMemberships", _descriptor20, this);
    _initializerDefineProperty(this, "isCustomSurcharge", _descriptor21, this);
    _initializerDefineProperty(this, "isPercentageSurcharge", _descriptor22, this);
    _initializerDefineProperty(this, "isPercentage", _descriptor23, this);
    _initializerDefineProperty(this, "isVariable", _descriptor24, this);
    _initializerDefineProperty(this, "percentageValue", _descriptor25, this);
    _initializerDefineProperty(this, "amountValue", _descriptor26, this);
    _initializerDefineProperty(this, "amountType", _descriptor27, this);
    _initializerDefineProperty(this, "isAutomatic", _descriptor28, this);
    // Tracks when the radio button to apply automatic weekly charges has been
    // selected. Needed to detect different invalid states:
    //  - Apply automatically selected but no weekly/holiday radio button selected.
    //  - Weekly radio button selected but no time periods specified.
    _initializerDefineProperty(this, "isAutoWeeklySelected", _descriptor29, this);
    // Tracks when the radio button to apply automatic holiday charges has been
    // selected. Needed to detect different invalid states:
    //  - Apply automatically selected but no weekly/holiday radio button selected.
    //  - Holiday radio button selected but no time periods specified.
    _initializerDefineProperty(this, "isAutoHolidaySelected", _descriptor30, this);
    _initializerDefineProperty(this, "hasWeeklyTimePeriods", _descriptor31, this);
    _initializerDefineProperty(this, "hasHolidayTimePeriods", _descriptor32, this);
    _initializerDefineProperty(this, "formattedAmount", _descriptor33, this);
    _initializerDefineProperty(this, "selectedTaxes", _descriptor34, this);
    _initializerDefineProperty(this, "isCardSurcharge", _descriptor35, this);
  }
  static catalogType() {
    return 'SURCHARGE';
  }
  get isDirty() {
    if ((this.surchargeFeeMemberships || []).any(sfm => sfm && sfm.isDirty)) {
      return true;
    }
    if (this.pricingRule && this.pricingRule.isDirty) {
      return true;
    }
    return super.isDirty;
  }
  setCalculationPhase(taxAssignmentType, isPercentage, isCardSurcharge) {
    if (isCardSurcharge) {
      set(this, 'calculationPhase', CalculationPhase.CARD_SURCHARGE_PHASE);
      return;
    }
    let calculationPhase = CalculationPhase.SURCHARGE_PHASE;
    const {
      treatmentType
    } = this.getTaxAssignmentTypeAttrs(taxAssignmentType);
    if (treatmentType === TreatmentType.APPORTIONED) {
      calculationPhase = isPercentage ? CalculationPhase.APPORTIONED_SURCHARGE_PERCENTAGE_PHASE : CalculationPhase.APPORTIONED_SURCHARGE_AMOUNT_PHASE;
    }
    set(this, 'calculationPhase', calculationPhase);
  }
  makeCardSurcharge(name) {
    if (!name) {
      throw new Error('name property is required for card surcharges');
    }
    const updatedProperties = {
      // Hard-code the name field for card surcharges
      name,
      surchargeType: SurchargeType.CARD_SURCHARGE,
      calculationPhase: CalculationPhase.CARD_SURCHARGE_PHASE
    };
    setProperties(this, updatedProperties);
    this.pricingRules.addObject(this.store.createRecord('pricing-rule', {
      surcharge: this,
      paymentType: PricingRule.PaymentType.CARD
    }));
  }
  surchargeFeeMembershipForFee(fee) {
    let membership = null;
    if (isPresent(fee.get('id'))) {
      membership = this.surchargeFeeMemberships.findBy('fee.id', fee.get('id'));
    } else {
      membership = this.surchargeFeeMemberships.findBy('fee', fee);
    }
    return membership;
  }
  addFeeMembership(fee) {
    let membership = this.surchargeFeeMembershipForFee(fee);
    if (membership) {
      membership.rollbackAttributes();
    } else {
      membership = this.store.createRecord('surcharge-fee-membership', {
        surcharge: this,
        fee
      });
      membership.set('globallyEnabled', this.globallyEnabled && fee.get('globallyEnabled'));
      if (!membership.globallyEnabled) {
        membership.setMerchantSubunits(this.commonSubunits(fee));
      }
    }
  }
  updateGloballyEnabledForRelationships() {
    this.surchargeFeeMemberships.forEach(surchargeFeeMembership => {
      surchargeFeeMembership.set('globallyEnabled', this.globallyEnabled && surchargeFeeMembership.fee.get('globallyEnabled'));
      if (!surchargeFeeMembership.globallyEnabled) {
        surchargeFeeMembership.setMerchantSubunits(this.commonSubunits(surchargeFeeMembership.fee));
      }
    });
    this.pricingRule?.inheritEnabledUnits(this);
  }
  getTaxAssignmentTypeAttrs(taxAssignmentType) {
    const taxAssignmentTypeMap = {
      [TaxAssignmentType.ASSIGNED]: {
        treatmentType: TreatmentType.LINE_ITEM,
        taxableNonItem: true
      },
      [TaxAssignmentType.APPORTIONED]: {
        treatmentType: TreatmentType.APPORTIONED,
        taxableNonItem: true
      },
      [TaxAssignmentType.NON_TAXABLE]: {
        treatmentType: this.isCardSurcharge ? TreatmentType.LINE_ITEM : TreatmentType.APPORTIONED,
        taxableNonItem: false
      }
    };
    return taxAssignmentTypeMap[taxAssignmentType];
  }
  getSurchargeTargetScope(treatmentType) {
    if (treatmentType === TreatmentType.LINE_ITEM) {
      return PricingRule.SurchargeTargetScope.SURCHARGE_TARGET_SCOPE_WHOLE_PURCHASE;
    } else {
      return PricingRule.SurchargeTargetScope.SURCHARGE_TARGET_SCOPE_LINE_ITEM;
    }
  }
  revert() {
    this.rollbackAttributes();
    this.surchargeFeeMemberships.forEach(surchargeFeeMembership => {
      if (surchargeFeeMembership) {
        surchargeFeeMembership.rollbackAttributes();
      }
    });
    this.pricingRule?.rollbackAttributes();
    this.isAutoWeeklySelected = false;
    this.isAutoHolidaySelected = false;
  }
  async save() {
    this.updateGloballyEnabledForRelationships();
    const result = await super.save();
    return result;
  }
  removeFeeMembership(fee) {
    const membership = this.surchargeFeeMembershipForFee(fee);
    if (membership) {
      membership.deleteRecord();
    }
  }
}, _defineProperty(_class2, "MAXIMUM_FRACTION_DIGITS", MAXIMUM_FRACTION_DIGITS), _defineProperty(_class2, "DEFAULT_VARIABLE_SURCHARGE_VALUE", DEFAULT_VARIABLE_SURCHARGE_VALUE), _defineProperty(_class2, "SurchargeType", SurchargeType), _defineProperty(_class2, "CalculationPhase", CalculationPhase), _defineProperty(_class2, "SurchargeCalculationType", SurchargeCalculationType), _defineProperty(_class2, "AutoEnableType", AutoEnableType), _defineProperty(_class2, "TreatmentType", TreatmentType), _defineProperty(_class2, "TaxAssignmentType", TaxAssignmentType), _defineProperty(_class2, "_modelNameForMigration", 'surcharge'), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "formatter", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "enabledUnitsAll", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "percentage", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "price", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "surchargeType", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "taxableNonItem", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "calculationPhase", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "surchargeCalculationType", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "calculationType", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "minimumSeatCount", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "autoEnableType", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "ecomApplyToFulfillmentTypes", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "treatmentType", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "pricingRules", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "pricingRule", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "taxAssignmentType", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "surchargeFeeMemberships", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "isCustomSurcharge", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "isPercentageSurcharge", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "isPercentage", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "isVariable", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "percentageValue", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "amountValue", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "amountType", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "isAutomatic", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "isAutoWeeklySelected", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "isAutoHolidaySelected", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "hasWeeklyTimePeriods", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "hasHolidayTimePeriods", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "formattedAmount", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isDirty", [_dec34], Object.getOwnPropertyDescriptor(_class.prototype, "isDirty"), _class.prototype), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "selectedTaxes", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "isCardSurcharge", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { Surcharge as default };